var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "htufimr6ka"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1011 -106) translate(-1 85)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.618 13.11l-7.806 6.971-3.641-3.255v-3.909l3.641 3.25L29.618 9.2v3.91zm-7.813-5.248c2.038 0 3.9.76 5.316 2.011l-1.308 1.167c-1.09-.9-2.485-1.44-4.008-1.44-3.476 0-6.293 2.817-6.293 6.293s2.817 6.293 6.293 6.293c3.431 0 6.22-2.746 6.291-6.16l1.631-1.456c.071.43.11.872.11 1.323 0 4.435-3.596 8.03-8.032 8.03-4.435 0-8.031-3.595-8.031-8.03 0-4.436 3.596-8.031 8.031-8.031zM4.04 10.372c-.232.033-.261-.128-.175-.25l2.756-3.43c.121-.15.253-.231.447-.255 4.892-.33 6.981-.294 11.854 0 .194.024.326.105.448.254l.374.466c.463-.109.941-.181 1.43-.216l-.988-1.213c-.12-.147-.381-.427-.874-.49-4.933-.311-7.7-.324-12.634 0-.492.063-.755.343-.874.49L3.55 8.5H.932c-.296 0-.607.244-.687.542l-.238.889c-.031.117.05.167.158.216l1.491.68-.606.744c-.368.467-.55 1.089-.537 1.875v7.457c0 .302.25.554.554.554h4.055c.305 0 .554-.25.554-.554v-.74h8.235c-.689-1.27-1.08-2.725-1.08-4.271 0-2.202.794-4.22 2.11-5.78-3.445-.059-6.641.02-10.901.26zm-1.723 1.83l3.614.449c.46.057.841.411.841.874v.674c0 .13-.11.236-.24.231l-3.614-.135c-.528-.02-.962-.47-.962-1v-.745c0-.199.164-.371.361-.347z",
    transform: "translate(1012 21)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsConfirm);
export default __webpack_public_path__ + "static/media/icons-confirm.7943e260a549533b0665091168fa5702.svg";
export { ForwardRef as ReactComponent };